import React from "react";
import { message, Modal } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";

import { deleteTask } from "../../api/task";
import { deleteProject } from "../../api/project";
import { deleteProjectUser } from "../../api/projectUser";
import { deleteProjectEquipment } from "../../api/projectEquipment";
import { deleteEquipment } from "../../api/equipment";
import { deleteUser } from "../../api/user";
import { deleteClient } from "../../api/client";

const { confirm } = Modal;

export default function RemoveItemModal({ type, id, refresh }) {
  const handleOk = async () => {
    try {
      if (type === "task") {
        const res = await deleteTask(id).then(() => {
          message.success("Task removed successfully");
        });
      } else if (type === "projects") {
        const res = await deleteProject(id).then(() => {
          message.success("Project removed successfully");
        });
      } else if (type === "employee") {
        const res = await deleteProjectUser(id).then(() => {
          message.success("Employee removed successfully");
        });
      } else if (type === "projectEquipment") {
        const res = await deleteProjectEquipment(id).then(() => {
          message.success("Equipment removed successfully");
        });
      } else if (type === "equipments") {
        await deleteEquipment(id).then(() => {
          message.success("Equipment removed successfully");
        });
      } else if (type === "users") {
        await deleteUser(id).then(() => {
          message.success("User removed successfully");
        });
      } else if (type === "clients") {
        await deleteClient(id).then(() => {
          message.success("Client removed successfully");
        });
      }
    } catch (error) {
      message.error("Something went wrong");
      console.log(error);
    }
  };

  return confirm({
    title: `Are you sure you want to remove this ${type}?`,
    icon: <ExclamationCircleFilled />,
    okText: "Remove",
    okType: "danger",
    cancelText: "Cancel",
    afterClose: () => refresh(),
    onOk() {
      handleOk();
    },
    onCancel() {
      console.log("Cancel");
    },
  });
}
